import React, { useLayoutEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useGetTaxAuditApp } from 'shared/hooks/api/useGetTaxAuditApp';
import { ACLoading } from 'shared/components';

interface MissingEntityTypeGuardProps {
  children: React.ReactNode;
}

const uuidPattern = /[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i;

const MissingEntityTypeGuard = ({ children }: MissingEntityTypeGuardProps) => {
  const [isChecked, setIsChecked] = useState(false);
  const location = useLocation();
  const id = location.pathname.match(uuidPattern)?.join('');
  const navigate = useNavigate();
  const { data: TaaData } = useGetTaxAuditApp(id);

  useLayoutEffect(() => {
    if (TaaData && id) {
      const hasMissingTypes = [
        TaaData.policyData?.primaryEntity,
        ...(TaaData.policyData?.additionalEntities || []),
      ].some(entity => !entity?.type);

      if (hasMissingTypes) {
        navigate(`/missing-entity-type/${id}`);
        return;
      }

      setIsChecked(true);
    }
  }, [TaaData, navigate, id]);

  if (!isChecked) return <ACLoading />;
  return <>{children}</>;
};

export default MissingEntityTypeGuard;
